import React from "react";

function Advertise() {
  return (
    <div className="slider" id="slider">
      <hr />
      <div className="slider__track">
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
        <p className="slide">Stay Chill</p>
      </div>
      <hr />
    </div>
  );
}

export default Advertise;
